import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c15a7ef&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c15a7ef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15a7ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c15a7ef')) {
      api.createRecord('0c15a7ef', component.options)
    } else {
      api.reload('0c15a7ef', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c15a7ef&scoped=true", function () {
      api.rerender('0c15a7ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/SortingLog/index.vue"
export default component.exports